import { render } from "./AddEditTemplateFile.vue?vue&type=template&id=723375aa&scoped=true"
import script from "./AddEditTemplateFile.vue?vue&type=script&lang=js"
export * from "./AddEditTemplateFile.vue?vue&type=script&lang=js"

import "./AddEditTemplateFile.vue?vue&type=style&index=0&id=723375aa&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-723375aa"]])

export default __exports__